module.exports = __webpack_public_path__ + "static/media/1006533.72336b41.png";